export default __webpack_public_path__ + "static/media/smaash.06d02ee9.png";